/**
 * This file was auto-generated by openapi-typescript.
 * Do not make direct changes to the file.
 */

export interface paths {
    "/contig/{contigId}/featureTypes": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** get available feature types by contig id. */
        get: operations["getContigFeatureTypes"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/contig/{contigId}/sequence": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** get sequence */
        get: operations["getSequence"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/contig/{contigId}/trackFeatures/{trackType}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** get track features of a give type by contig ids. Subtype is optional for gene and protein types. */
        get: operations["getTrackFeatures"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/feature/{type}/{featureId}/info": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** get feature by type and id. */
        get: operations["getFeature"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/feature/{type}/{featureId}/locations": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** get feature locations */
        get: operations["getFeatureLocation"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/genome/componentGenomes/{orgId}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** get component genomes by orgId */
        get: operations["getComponentGenomes"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/genome/{orgId}/info": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** get genome info */
        get: operations["getGenomeInfo"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/search/genomicFeature": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** get search results for the provided term */
        post: operations["getSearchResult"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/sequenceAnalyzer/createSession": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** create sequence analyzer session */
        post: operations["createSession"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/sequenceAnalyzer/createSessionFromRanges": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** create sequence analyzer session from regions */
        post: operations["createSessionFromRanges"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/sequenceAnalyzer/sequenceFeatureColors/{sequenceType}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Get colors */
        get: operations["getSequenceFeatureColors"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/sequenceAnalyzer/session/{seqAnalyzerSessionId}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** obtain session with the given ID */
        get: operations["getSeqAnalyzerSession"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/sequenceAnalyzer/session/{seqAnalyzerSessionId}/isValid": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** check whether the session is still available */
        get: operations["isSessionValid"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/sequenceAnalyzer/session/{seqAnalyzerSessionId}/sequences": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** add sequences to session */
        post: operations["addSequencesToSession"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/sequenceAnalyzer/session/{seqAnalyzerSessionId}/strands": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** switch specified sequences to opposite strand */
        post: operations["switchStrand"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/sequenceAnalyzer/validateSequences": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** validate sequences to have valid contents */
        post: operations["validateSequences"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/sequences/align": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** Align Sequences */
        post: operations["align"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/sequences/order": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** Order sequences by similarity */
        post: operations["order"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/sequences/tree": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** Calculate Similarity Tree of Sequences */
        post: operations["tree"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/sequences/{seqAnalyzerSessionId}/report": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** Order sequences to FASTA/MSF file */
        post: operations["exportFile"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/synteny/geneFamily/{familyId}/members": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** get gene family members by familyId */
        get: operations["getGeneFamilyMembers"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/synteny/proteinFamily/{familyId}/members": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** get protein family members by familyId */
        get: operations["getProteinFamilyMembers"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/synteny/{pangenomeOrgId}/pangenomeAlignment/{familyId}/members": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** get pangenome alignment members by familyId */
        get: operations["getPangenomeAlignmentMembers"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/synteny/{pangenomeOrgId}/{contigId}/pangenomeAlignments": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** get pangenome aligned regions by contig id */
        get: operations["getPangenomeAlignments"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/synteny/{pangenomeOrgId}/{contigId}/pangenomeAlignments/statistics": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * get pangenome alignment statistics by contig id
         * @description Set of statistics indication how many features with a minimum length exist for a specified region.Lengths reference is provided separately in the parent object.
         */
        get: operations["getAlignmentStatistics"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/synteny/{pangenomeOrgId}/{contigId}/trackFeatures": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** get pangenome track features of a given type by contig id. */
        get: operations["getPangenomeTrackFeatures"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/synteny/{syntenyOrgId}/componentGenome/{orgId}/{syntenyType}/alignedContigs": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** get contigs with synteny families by orgId */
        get: operations["getContigsWithSyntenyFamilies"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/synteny/{syntenyOrgId}/geneFamilies": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** get gene families by contig ids and synteny organism id */
        get: operations["getGeneFamilies"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/synteny/{syntenyOrgId}/proteinFamilies": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** get protein families by contig ids and synteny organism id */
        get: operations["getProteinFamilies"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/synteny/{syntenyOrgId}/{syntenyType}/feature/{featureId}/syntenyMembers": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** get family members of a synteny feature */
        get: operations["getFeatureSyntenyFamilyMembers"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/view/synteny": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        /** edit a synteny view */
        put: operations["editSyntenyView"];
        /** create a synteny view */
        post: operations["createSyntenyView"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/view/synteny/{viewId}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** load synteny view */
        get: operations["loadSyntenyView"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
}
export type webhooks = Record<string, never>;
export interface components {
    schemas: {
        /** Aligned Family Request */
        AlignedFamilyRequest: {
            /** Format: int64 */
            familyId: number;
            members: components["schemas"]["FamilyMemberRequest"][];
        };
        /** Aligned Family Response */
        AlignedFamilyResponse: {
            /** Format: int64 */
            familyId: number;
            members: components["schemas"]["FamilyMemberResponse"][];
        };
        /** Alignment Bin Stats */
        AlignmentBinStatsResponse: {
            /** @description Each element contain the total count of features with at least the length related to the reference field of the parent object. */
            counts: number[];
            /** Format: int32 */
            start: number;
            /** Format: int32 */
            stop: number;
        };
        /**
         * Alignment Density
         * @enum {string}
         */
        AlignmentDensityEnum: AlignmentDensityEnum;
        /** Alignment Options */
        AlignmentOptions: {
            methodKey: components["schemas"]["MethodKeyEnum"];
            sequences?: components["schemas"]["SlowAlignmentOptions"];
        };
        /** Alignment Stats */
        AlignmentStatsResponse: {
            /** @description Statistics bin counter reference. Elements in the bin counter array contain a length greater than the reference here. */
            binCountsReference: number[];
            bins: components["schemas"]["AlignmentBinStatsResponse"][];
        };
        /**
         * Basic Entity Sequence
         * @description An Entity containing a sequence, such as a Gene, a Transcript or Protein without Feature details
         */
        BasicEntitySequence: {
            /** @default true */
            directStrand: boolean;
            /** Format: int64 */
            id: number;
            name: string;
            qualifiedId: string;
            residues: string;
            sequenceType: components["schemas"]["SequenceType"];
        };
        /** Category Response */
        CategoryResponse: {
            categoryName: string;
            categoryType: components["schemas"]["GenomicFeatureTypeEnum"];
            items: components["schemas"]["ItemResponse"][];
            /** Format: int64 */
            subTypeId: number;
            /** Format: int64 */
            totalItemCount: number;
        };
        /**
         * Contig Region
         * @description Representation of a region on a contig
         */
        ContigRange: {
            /** Format: int64 */
            contigId: number;
            /** Format: int64 */
            start: number;
            /** Format: int64 */
            stop: number;
            trackColors?: components["schemas"]["TrackColors"];
        };
        /** Contig */
        ContigResponse: {
            /** Format: int64 */
            id: number;
            /** Format: int64 */
            length: number;
            name: string;
        };
        /** Create or Update Synteny View Request */
        CreateOrUpdateSyntenyViewRequest: {
            description?: string;
            /** Format: int64 */
            id?: number;
            itemTagIds?: number[];
            name: string;
            path: string;
            /** Format: int64 */
            projectId: number;
            shared: boolean;
            state: components["schemas"]["StateRequest"];
        };
        /** Distance Tree Node */
        DistanceTreeNode: {
            /** Format: double */
            distance?: number;
            /** Format: int64 */
            id?: number;
            left?: components["schemas"]["DistanceTreeNode"];
            right?: components["schemas"]["DistanceTreeNode"];
        };
        /**
         * Entity Sequence
         * @description An Entity containing a sequence, such as a Gene, a Transcript or Protein
         */
        EntitySequence: {
            chainInfoKey?: string;
            chainInfoLabel?: string;
            circular?: boolean;
            database: string;
            description?: string;
            /** @default true */
            directStrand: boolean;
            entityClassLabelPlural?: string;
            entityClassLabelSingular?: string;
            entityDescription?: string;
            entityLabel?: string;
            entityQualifiedId?: string;
            entityUrl?: string;
            featureType: components["schemas"]["FeatureType"];
            features: components["schemas"]["SequenceFeature"][];
            genome: string;
            /** Format: int64 */
            id: number;
            location?: string;
            name: string;
            qualifiedId: string;
            residues: string;
            sequenceType: components["schemas"]["SequenceType"];
            synonym?: string;
        };
        /** Export Sequences in FASTA/MSF file Request */
        ExportFileRequest: {
            "The  sequence selection"?: components["schemas"]["Selection"];
            "The type of the export file": components["schemas"]["SequenceExportFileType"];
            alignedSequences: components["schemas"]["SequenceAlign"][];
            entitySequences: components["schemas"]["BasicEntitySequence"][];
        };
        /** External Reference */
        ExternalReferenceResponse: {
            displayName: string;
            link: string;
        };
        /** Family Member Request */
        FamilyMemberRequest: {
            /** Format: int64 */
            featureId: number;
            trackId: string;
        };
        /** Family Member Response */
        FamilyMemberResponse: {
            /** Format: int64 */
            featureId: number;
            trackId: string;
        };
        /** Feature Contig Location */
        FeatureContigLocationResponse: {
            /** Format: int64 */
            contigId: number;
            /** Format: int64 */
            featureId: number;
            /** Format: int64 */
            otherGenomesMemberCount?: number;
            /** Format: int64 */
            sameGenomeMemberCount?: number;
        };
        /**
         * Feature Location
         * @description Represents basic location information of a feature for the context entity.
         */
        FeatureLocationResponse: {
            /** Format: int64 */
            contigId: number;
            contigSequenceId: string;
            /** Format: int64 */
            id: number;
            name: string;
            range: components["schemas"]["RangeResponse"];
            /** Format: int64 */
            subTypeId?: number;
            subTypeName?: string;
        };
        /**
         * Feature
         * @description Represents basic information of a feature for the context entity.
         */
        FeatureResponse: {
            description?: string;
            extReferences?: components["schemas"]["ExternalReferenceResponse"][];
            gene?: components["schemas"]["GeneInfoResponse"];
            /** Format: int64 */
            id: number;
            name: string;
            pValue?: string;
            protein?: components["schemas"]["ProteinInfoResponse"];
            score?: number;
            /** Format: int64 */
            sequenceTypeId?: number;
            /** Format: int64 */
            start?: number;
            status?: string;
            /** Format: int64 */
            stop?: number;
            strand?: string;
            synonyms?: string[];
        };
        /**
         * Feature Type
         * @enum {string}
         */
        FeatureType: FeatureType;
        /**
         * FeatureType
         * @description Represents a feature type for the context entity.
         */
        FeatureTypeResponse: {
            /** Format: int64 */
            count?: number;
            /** Format: int64 */
            id: number;
            name: string;
        };
        /**
         * Feature Type Track Colors
         * @description Coloring of feature tracks per Contig
         */
        FeatureTypeTrackColor: {
            color: string;
            /** Format: int64 */
            featureTypeId: number;
        };
        /**
         * FeatureTypes
         * @description Represents all available feature types for the context entity.
         */
        FeatureTypesResponse: {
            aaFeatureTypes: components["schemas"]["FeatureTypeResponse"][];
            markerTypes: components["schemas"]["FeatureTypeResponse"][];
            nuFeatureTypes: components["schemas"]["FeatureTypeResponse"][];
        };
        /**
         * Gene info
         * @description Gene basic information.
         */
        GeneInfoResponse: {
            description?: string;
            /** Format: int64 */
            id: number;
            name: string;
        };
        /** Genome Category Response */
        GenomeCategoryResponse: {
            categoryResponses: components["schemas"]["CategoryResponse"][];
            /** Format: int64 */
            genomeId: number;
            genomeName: string;
        };
        /**
         * Genome info
         * @description Genome basic information.
         */
        GenomeInfoResponse: {
            customId: string;
            description?: string;
            /** Format: int64 */
            id: number;
            identifier: string;
            isVirtual: boolean;
            name: string;
            sequencingType: components["schemas"]["SequencingTypeEnum"];
            version?: string;
        };
        /** @enum {string} */
        GenomicFeatureTypeEnum: GenomicFeatureTypeEnum;
        /** Graphics Request */
        GraphicsRequest: {
            /** Format: int32 */
            baseShift: number;
            isVisible: boolean;
            /** Format: int32 */
            length: number;
        };
        /** Graphics Response */
        GraphicsResponse: {
            /** Format: int32 */
            baseShift: number;
            isVisible: boolean;
            /** Format: int32 */
            length: number;
        };
        /** Invalid Sequences Response */
        InvalidSequencesResponse: {
            messages?: components["schemas"]["Message"][];
            payload: string[];
        };
        /** Item Response */
        ItemResponse: {
            /** Format: int64 */
            contigId: number;
            contigName: string;
            /** Format: int64 */
            id: number;
            name: string;
            /** Format: int64 */
            orgId: number;
            orgName: string;
            seqId: string;
            /** Format: int64 */
            start: number;
            /** Format: int64 */
            stop: number;
        };
        /** Item Tag */
        ItemTagResponse: {
            color?: string;
            /** Format: int64 */
            id: number;
            name: string;
            /** Format: int64 */
            projectId: number;
        };
        /** Message */
        Message: {
            severity: components["schemas"]["SeverityConstants"];
            text: string;
        };
        /**
         * Method Key
         * @enum {string}
         */
        MethodKeyEnum: MethodKeyEnum;
        /** Open File Payload */
        OpenFilePayload: {
            alignedSequences?: components["schemas"]["SequenceAlign"][];
            entitySequences: components["schemas"]["EntitySequence"][];
        };
        /** Open File Request */
        OpenFileRequest: {
            fileContent: components["schemas"]["TextFile"];
        };
        /** Open File Response */
        OpenFileResponse: {
            messages?: components["schemas"]["Message"][];
            payload?: components["schemas"]["OpenFilePayload"];
        };
        /** Organism */
        OrganismResponse: {
            contigs: components["schemas"]["ContigResponse"][];
            /** Format: int64 */
            id: number;
            name: string;
        };
        /**
         * Pileup Rendering Mode
         * @enum {string}
         */
        PileupRenderingModeEnum: PileupRenderingModeEnum;
        /**
         * Protein info
         * @description Protein basic information.
         */
        ProteinInfoResponse: {
            accession: string;
            description?: string;
            /** Format: int64 */
            id: number;
            name: string;
            sequenceId: string;
            /** Format: int32 */
            version: number;
        };
        /** Range Response */
        RangeResponse: {
            /** Format: int64 */
            start: number;
            /** Format: int64 */
            stop: number;
        };
        /** Search Feature Request */
        SearchFeatureRequest: {
            /** Format: int64 */
            genomeId: number;
            /** Format: int32 */
            limit?: number;
            searchTerm: string;
            types: components["schemas"]["SearchGenomicEntityTypeRequest"][];
        };
        /** Search Feature Response */
        SearchFeatureResponse: {
            categories: components["schemas"]["GenomeCategoryResponse"][];
        };
        /** Search Genomic Entity Type Request */
        SearchGenomicEntityTypeRequest: {
            subTypeIds?: number[];
            type: components["schemas"]["GenomicFeatureTypeEnum"];
        };
        /**
         * Sequence selection
         * @description The part of the sequence selected
         */
        Selection: {
            /** Format: int32 */
            positionEnd: number;
            /** Format: int32 */
            positionStart: number;
        };
        /**
         * Sequence Align
         * @description Representation of aligned sequence residues
         */
        SequenceAlign: {
            /** Format: int64 */
            id: number;
            residues: string;
        };
        /**
         * Sequence Analyzer Feature Type
         * @enum {string}
         */
        SequenceAnalyzerFeatureType: SequenceAnalyzerFeatureType;
        /**
         * File Type
         * @enum {string}
         */
        SequenceExportFileType: SequenceExportFileType;
        /** Sequence Feature */
        SequenceFeature: {
            color?: string;
            description?: string;
            directStrand: boolean;
            forceColor?: string;
            /** Format: int64 */
            id: number;
            name?: string;
            /** Format: double */
            score?: number;
            /** Format: int32 */
            start: number;
            /** Format: int32 */
            stop: number;
            type: string;
            /** Format: int64 */
            typeId?: number;
            typeKey?: string;
        };
        /**
         * Sequence feature color
         * @description Color specified by default or updated by a user for either a feature type of feature name
         */
        SequenceFeatureColor: {
            color?: string;
            /** Format: int64 */
            featureTypeId: number;
            label?: boolean;
            setting?: components["schemas"]["SequenceFeatureTypeColorSetting"];
        };
        /** Sequence feature colors */
        SequenceFeatureColorsResponse: {
            messages?: components["schemas"]["Message"][];
            payload?: components["schemas"]["SequenceFeatureColor"][];
        };
        /**
         * Sequence Feature Type Color Setting
         * @enum {string}
         */
        SequenceFeatureTypeColorSetting: SequenceFeatureTypeColorSetting;
        /**
         * Sequence Type
         * @enum {string}
         */
        SequenceType: SequenceType;
        /** Sequences Align Payload */
        SequencesAlignPayload: {
            sequences: components["schemas"]["SequenceAlign"][];
        };
        /** Sequences Align Request */
        SequencesAlignRequest: {
            alignmentOptions: components["schemas"]["AlignmentOptions"];
            sequences: components["schemas"]["SequenceAlign"][];
        };
        /** Sequences Align Response */
        SequencesAlignResponse: {
            messages?: components["schemas"]["Message"][];
            payload?: components["schemas"]["SequencesAlignPayload"];
        };
        /**
         * Sequencing Type
         * @enum {string}
         */
        SequencingTypeEnum: SequencingTypeEnum;
        /** Session */
        Session: {
            alignedSequences?: components["schemas"]["SequenceAlign"][];
            alignmentOptionsDescription: string;
            alignmentToolLabel: string;
            canCreateHitList: boolean;
            cannotCreateHitListMessage?: string;
            createHitListLabel: string;
            documentationLabel: string;
            documentationUrl: string;
            entitySequences: components["schemas"]["EntitySequence"][];
            id: string;
            maskingResidue?: string;
            sequenceClassLabelPlural: string;
            sequenceClassLabelSingular: string;
            sequenceType: components["schemas"]["SequenceType"];
        };
        /** Session From Ranges Request */
        SessionFromRangesRequest: {
            ranges?: components["schemas"]["ContigRange"][];
        };
        /** Session Request */
        SessionRequest: {
            featureType?: components["schemas"]["SequenceAnalyzerFeatureType"];
            sequenceIds?: number[];
        };
        /** Session Validity Response */
        SessionValidityResponse: {
            messages?: components["schemas"]["Message"][];
            payload?: components["schemas"]["Session"];
            type?: string;
        };
        /**
         * Severity Constants
         * @enum {string}
         */
        SeverityConstants: SeverityConstants;
        /** Similarity Tree Request */
        SimilarityTreeRequest: {
            sequences: components["schemas"]["SequenceAlign"][];
        };
        /** Similarity Tree Response */
        SimilarityTreeResponse: {
            messages?: components["schemas"]["Message"][];
            payload?: components["schemas"]["DistanceTreeNode"];
        };
        /** Slow Alignment Options */
        SlowAlignmentOptions: {
            /**
             * Format: double
             * @description Maps to ClustalW GAPOPEN parameter: gap opening penalty
             */
            gapCreationPenalty?: number;
            /** Format: double */
            gapExtensionPenalty?: number;
            /** Format: int32 */
            identity?: number;
        };
        /** State Request */
        StateRequest: {
            /** Format: int64 */
            activeMemberId?: number;
            alignedFamily?: components["schemas"]["AlignedFamilyRequest"];
            alignmentDensity: components["schemas"]["AlignmentDensityEnum"];
            /** Format: double */
            basePerPixel: number;
            /** Format: int64 */
            organismId: number;
            pileupRenderingMode: components["schemas"]["PileupRenderingModeEnum"];
            /** Format: double */
            scrollX: number;
            /** Format: double */
            scrollY: number;
            trackGroups: components["schemas"]["TrackGroupRequest"][];
            tracks: components["schemas"]["TrackRequest"][];
        };
        /** State Response */
        StateResponse: {
            /** Format: int64 */
            activeMemberId?: number;
            alignedFamily?: components["schemas"]["AlignedFamilyResponse"];
            alignmentDensity: components["schemas"]["AlignmentDensityEnum"];
            /** Format: double */
            basePerPixel: number;
            /** Format: int64 */
            organismId: number;
            pileupRenderingMode: components["schemas"]["PileupRenderingModeEnum"];
            /** Format: double */
            scrollX: number;
            /** Format: double */
            scrollY: number;
            trackGroups: components["schemas"]["TrackGroupResponse"][];
            tracks: components["schemas"]["TrackResponse"][];
        };
        /** Strands Payload */
        StrandsPayload: {
            entitySequences: components["schemas"]["EntitySequence"][];
        };
        /** Strands Request */
        StrandsRequest: {
            entitySequences: components["schemas"]["EntitySequence"][];
        };
        /** Strands Response */
        StrandsResponse: {
            messages?: components["schemas"]["Message"][];
            payload?: components["schemas"]["StrandsPayload"];
        };
        /** Synteny Family Contig */
        SyntenyFamilyContigResponse: {
            /** Format: int64 */
            contigId: number;
            contigName: string;
            /** Format: int64 */
            length: number;
            members: components["schemas"]["SyntenyFamilyMemberResponse"][];
        };
        /** Synteny Family Member */
        SyntenyFamilyMemberResponse: {
            /** Format: int64 */
            locationId: number;
            /** Format: int64 */
            memberId: number;
            memberName: string;
            /** Format: int64 */
            start: number;
            /** Format: int64 */
            stop: number;
        };
        /** Synteny Family Organism */
        SyntenyFamilyOrganismResponse: {
            contigs: components["schemas"]["SyntenyFamilyContigResponse"][];
            /** Format: int64 */
            organismId: number;
            organismName: string;
        };
        /** Synteny Family */
        SyntenyFamilyResponse: {
            /** Format: int64 */
            id: number;
            members: components["schemas"]["FeatureContigLocationResponse"][];
        };
        /** @enum {string} */
        SyntenyTypeEnum: SyntenyTypeEnum;
        /** Synteny View */
        SyntenyViewResponse: {
            description?: string;
            /** Format: int64 */
            id: number;
            itemTags?: components["schemas"]["ItemTagResponse"][];
            path: string;
            /** Format: int64 */
            projectId: number;
            shared: boolean;
            state: components["schemas"]["StateResponse"];
            viewLabel: string;
            viewName: string;
            viewType: string;
        };
        /** Text File */
        TextFile: {
            content?: string;
            encoding?: string;
            name?: string;
        };
        /**
         * Track Colors
         * @description Coloring of tracks per Contig
         */
        TrackColors: {
            gene?: string;
            nuFeatures?: components["schemas"]["FeatureTypeTrackColor"][];
            protein?: string;
        };
        /** @enum {string} */
        TrackEnum: TrackEnum;
        /** Track feature */
        TrackFeatureResponse: {
            /** Format: int64 */
            id: number;
            mappings?: components["schemas"]["RangeResponse"][];
            name: string;
            representer: boolean;
            /** Format: int64 */
            start: number;
            /** Format: int64 */
            stop: number;
            strand?: string;
        };
        /** Track Group Request */
        TrackGroupRequest: {
            /** Format: int64 */
            contigId: number;
            graphics: components["schemas"]["GraphicsRequest"];
            groupId: string;
            /** Format: int64 */
            organismId: number;
            trackIds: string[];
        };
        /** Track Group Response */
        TrackGroupResponse: {
            /** Format: int64 */
            contigId: number;
            contigSequenceId: string;
            graphics: components["schemas"]["GraphicsResponse"];
            groupId: string;
            /** Format: int64 */
            organismId: number;
            organismName: string;
            trackIds: string[];
        };
        /** Track Request */
        TrackRequest: {
            /** Format: double */
            basePerPixel: number;
            /** Format: int32 */
            baseStart: number;
            color: string;
            groupId: string;
            /** Format: int32 */
            height: number;
            isVisible: boolean;
            /** Format: int64 */
            subTypeId?: number;
            synteny: boolean;
            text: components["schemas"]["TrackTextEnum"];
            trackId: string;
            trackType: components["schemas"]["TrackEnum"];
            /** Format: int32 */
            width: number;
        };
        /** Track Response */
        TrackResponse: {
            /** Format: double */
            basePerPixel: number;
            /** Format: int32 */
            baseStart: number;
            color: string;
            groupId: string;
            /** Format: int32 */
            height: number;
            isVisible: boolean;
            subType?: components["schemas"]["FeatureTypeResponse"];
            /** Format: int64 */
            subTypeId?: number;
            synteny: boolean;
            text: components["schemas"]["TrackTextEnum"];
            trackId: string;
            trackType: components["schemas"]["TrackEnum"];
            /** Format: int32 */
            width: number;
        };
        /**
         * Track Text
         * @enum {string}
         */
        TrackTextEnum: TrackTextEnum;
    };
    responses: never;
    parameters: never;
    requestBodies: never;
    headers: never;
    pathItems: never;
}
export type $defs = Record<string, never>;
export interface operations {
    getContigFeatureTypes: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                contigId: number;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful operation. */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["FeatureTypesResponse"];
                };
            };
            /** @description Validation exception: the request cannot be performed for the given input due to problems with the input.
             *     Example: user is not allowed to access referenced entities.
             *      */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Unauthorized API access. */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Not found exception: one of the referenced entities doesn't exist. */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Internal server error. */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    getSequence: {
        parameters: {
            query?: {
                /** @description range start position */
                start?: number;
                /** @description range stop position */
                stop?: number;
                /** @description strand, defaults to + */
                strand?: string;
            };
            header?: never;
            path: {
                /** @description contig id */
                contigId: number;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful operation. */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "text/plain": string;
                };
            };
            /** @description Validation exception: the request cannot be performed for the given input due to problems with the input.
             *     Example: user is not allowed to access referenced entities.
             *      */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Unauthorized API access. */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Not found exception: one of the referenced entities doesn't exist. */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Internal server error. */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    getTrackFeatures: {
        parameters: {
            query?: {
                /** @description Track feature subtype id */
                subtypeId?: number;
                /** @description range start position */
                start?: number;
                /** @description range stop position */
                stop?: number;
                /** @description synteny organism id (used to improve condensed mode) */
                syntenyOrgId?: number;
                condense?: boolean;
            };
            header?: never;
            path: {
                contigId: number;
                trackType: components["schemas"]["TrackEnum"];
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful operation. */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["TrackFeatureResponse"][];
                };
            };
            /** @description Validation exception: the request cannot be performed for the given input due to problems with the input.
             *     Example: user is not allowed to access referenced entities.
             *      */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Unauthorized API access. */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Not found exception: one of the referenced entities doesn't exist. */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Internal server error. */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    getFeature: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                type: components["schemas"]["GenomicFeatureTypeEnum"];
                featureId: number;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful operation. */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["FeatureResponse"];
                };
            };
            /** @description Validation exception: the request cannot be performed for the given input due to problems with the input.
             *     Example: user is not allowed to access referenced entities.
             *      */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Unauthorized API access. */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Not found exception: one of the referenced entities doesn't exist. */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Internal server error. */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    getFeatureLocation: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                type: components["schemas"]["GenomicFeatureTypeEnum"];
                featureId: number;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful operation. */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["FeatureLocationResponse"][];
                };
            };
            /** @description Validation exception: the request cannot be performed for the given input due to problems with the input.
             *     Example: user is not allowed to access referenced entities.
             *      */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Unauthorized API access. */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Not found exception: one of the referenced entities doesn't exist. */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Internal server error. */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    getComponentGenomes: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description organism id */
                orgId: number;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful operation. */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["OrganismResponse"][];
                };
            };
            /** @description Validation exception: the request cannot be performed for the given input due to problems with the input.
             *     Example: user is not allowed to access referenced entities.
             *      */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Unauthorized API access. */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Not found exception: one of the referenced entities doesn't exist. */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Internal server error. */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    getGenomeInfo: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description organism id */
                orgId: number;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful operation. */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["GenomeInfoResponse"];
                };
            };
            /** @description Validation exception: the request cannot be performed for the given input due to problems with the input.
             *     Example: user is not allowed to access referenced entities.
             *      */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Unauthorized API access. */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Not found exception: one of the referenced entities doesn't exist. */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Internal server error. */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    getSearchResult: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @description genomic feature search request */
        requestBody: {
            content: {
                "application/json": components["schemas"]["SearchFeatureRequest"];
            };
        };
        responses: {
            /** @description Successful operation. */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["SearchFeatureResponse"];
                };
            };
            /** @description Validation exception: the request cannot be performed for the given input due to problems with the input.
             *     Example: user is not allowed to access referenced entities.
             *      */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Unauthorized API access. */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Not found exception: one of the referenced entities doesn't exist. */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Internal server error. */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    createSession: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @description sequence ids payload */
        requestBody: {
            content: {
                "application/json": components["schemas"]["SessionRequest"];
            };
        };
        responses: {
            /** @description Successful operation. */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "text/plain": string;
                };
            };
            /** @description Validation exception: the request cannot be performed for the given input due to problems with the input.
             *     Example: user is not allowed to access referenced entities.
             *      */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Unauthorized API access. */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Not found exception: one of the referenced entities doesn't exist. */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Internal server error. */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    createSessionFromRanges: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @description sequence ranges payload */
        requestBody: {
            content: {
                "application/json": components["schemas"]["SessionFromRangesRequest"];
            };
        };
        responses: {
            /** @description Successful operation. */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "text/plain": string;
                };
            };
            /** @description Validation exception: the request cannot be performed for the given input due to problems with the input.
             *     Example: user is not allowed to access referenced entities.
             *      */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Unauthorized API access. */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Not found exception: one of the referenced entities doesn't exist. */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Internal server error. */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    getSequenceFeatureColors: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description Get current users' colors for a given sequence type */
                sequenceType: components["schemas"]["SequenceType"];
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful operation. */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["SequenceFeatureColorsResponse"];
                };
            };
            /** @description Validation exception: the request cannot be performed for the given input due to problems with the input.
             *     Example: user is not allowed to access referenced entities.
             *      */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Unauthorized API access. */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Not found exception: one of the referenced entities doesn't exist. */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Internal server error. */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    getSeqAnalyzerSession: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description sequence analyzer session id */
                seqAnalyzerSessionId: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful operation. */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["Session"];
                };
            };
            /** @description Validation exception: the request cannot be performed for the given input due to problems with the input.
             *     Example: user is not allowed to access referenced entities.
             *      */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Unauthorized API access. */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Not found exception: one of the referenced entities doesn't exist. */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Internal server error. */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    isSessionValid: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description sequence analyzer session id */
                seqAnalyzerSessionId: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful operation. */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["SessionValidityResponse"];
                };
            };
            /** @description Validation exception: the request cannot be performed for the given input due to problems with the input.
             *     Example: user is not allowed to access referenced entities.
             *      */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Unauthorized API access. */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Not found exception: one of the referenced entities doesn't exist. */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Internal server error. */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    addSequencesToSession: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description sequence analyzer session id */
                seqAnalyzerSessionId: string;
            };
            cookie?: never;
        };
        /** @description sequences payload */
        requestBody: {
            content: {
                "application/json": components["schemas"]["OpenFileRequest"];
            };
        };
        responses: {
            /** @description Successful operation. */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["OpenFileResponse"];
                };
            };
            /** @description Validation exception: the request cannot be performed for the given input due to problems with the input.
             *     Example: user is not allowed to access referenced entities.
             *      */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Unauthorized API access. */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Not found exception: one of the referenced entities doesn't exist. */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Internal server error. */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    switchStrand: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description sequence analyzer session id */
                seqAnalyzerSessionId: string;
            };
            cookie?: never;
        };
        /** @description sequences payload */
        requestBody: {
            content: {
                "application/json": components["schemas"]["StrandsRequest"];
            };
        };
        responses: {
            /** @description Successful operation. */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["StrandsResponse"];
                };
            };
            /** @description Validation exception: the request cannot be performed for the given input due to problems with the input.
             *     Example: user is not allowed to access referenced entities.
             *      */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Unauthorized API access. */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Not found exception: one of the referenced entities doesn't exist. */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Internal server error. */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    validateSequences: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @description sequence ids payload */
        requestBody: {
            content: {
                "application/json": components["schemas"]["SessionRequest"];
            };
        };
        responses: {
            /** @description Successful operation. */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["InvalidSequencesResponse"];
                };
            };
            /** @description Validation exception: the request cannot be performed for the given input due to problems with the input.
             *     Example: user is not allowed to access referenced entities.
             *      */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Unauthorized API access. */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Not found exception: one of the referenced entities doesn't exist. */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Internal server error. */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    align: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @description sequences align request */
        requestBody: {
            content: {
                "application/json": components["schemas"]["SequencesAlignRequest"];
            };
        };
        responses: {
            /** @description Successful operation. */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["SequencesAlignResponse"];
                };
            };
            /** @description Validation exception: the request cannot be performed for the given input due to problems with the input.
             *     Example: user is not allowed to access referenced entities.
             *      */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Unauthorized API access. */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Not found exception: one of the referenced entities doesn't exist. */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Internal server error. */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    order: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @description sequences align request */
        requestBody: {
            content: {
                "application/json": components["schemas"]["SequencesAlignRequest"];
            };
        };
        responses: {
            /** @description Successful operation. */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["SequencesAlignResponse"];
                };
            };
            /** @description Validation exception: the request cannot be performed for the given input due to problems with the input.
             *     Example: user is not allowed to access referenced entities.
             *      */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Unauthorized API access. */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Not found exception: one of the referenced entities doesn't exist. */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Internal server error. */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    tree: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @description sequences similarity tree request */
        requestBody: {
            content: {
                "application/json": components["schemas"]["SimilarityTreeRequest"];
            };
        };
        responses: {
            /** @description Successful operation. */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["SimilarityTreeResponse"];
                };
            };
            /** @description Validation exception: the request cannot be performed for the given input due to problems with the input.
             *     Example: user is not allowed to access referenced entities.
             *      */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Unauthorized API access. */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Not found exception: one of the referenced entities doesn't exist. */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Internal server error. */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    exportFile: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description sequence analyzer session id */
                seqAnalyzerSessionId: string;
            };
            cookie?: never;
        };
        /** @description sequences export request */
        requestBody: {
            content: {
                "application/json": components["schemas"]["ExportFileRequest"];
            };
        };
        responses: {
            /** @description Successful operation. */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "text/plain": string;
                };
            };
            /** @description Validation exception: the request cannot be performed for the given input due to problems with the input.
             *     Example: user is not allowed to access referenced entities.
             *      */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Unauthorized API access. */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Not found exception: one of the referenced entities doesn't exist. */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Internal server error. */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    getGeneFamilyMembers: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                familyId: number;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful operation. */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["SyntenyFamilyOrganismResponse"][];
                };
            };
            /** @description Validation exception: the request cannot be performed for the given input due to problems with the input.
             *     Example: user is not allowed to access referenced entities.
             *      */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Unauthorized API access. */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Not found exception: one of the referenced entities doesn't exist. */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Internal server error. */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    getProteinFamilyMembers: {
        parameters: {
            query?: {
                condense?: boolean;
            };
            header?: never;
            path: {
                familyId: number;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful operation. */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["SyntenyFamilyOrganismResponse"][];
                };
            };
            /** @description Validation exception: the request cannot be performed for the given input due to problems with the input.
             *     Example: user is not allowed to access referenced entities.
             *      */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Unauthorized API access. */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Not found exception: one of the referenced entities doesn't exist. */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Internal server error. */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    getPangenomeAlignmentMembers: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description pangenome organism id */
                pangenomeOrgId: number;
                familyId: number;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful operation. */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["SyntenyFamilyOrganismResponse"][];
                };
            };
            /** @description Validation exception: the request cannot be performed for the given input due to problems with the input.
             *     Example: user is not allowed to access referenced entities.
             *      */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Unauthorized API access. */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Not found exception: one of the referenced entities doesn't exist. */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Internal server error. */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    getPangenomeAlignments: {
        parameters: {
            query?: {
                /** @description range start position */
                start?: number;
                /** @description range stop position */
                stop?: number;
                /** @description feature minimum length */
                minLength?: number;
            };
            header?: never;
            path: {
                /** @description pangenome organism id */
                pangenomeOrgId: number;
                /** @description contig id part of the pangenome */
                contigId: number;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful operation. */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["SyntenyFamilyResponse"][];
                };
            };
            /** @description Validation exception: the request cannot be performed for the given input due to problems with the input.
             *     Example: user is not allowed to access referenced entities.
             *      */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Unauthorized API access. */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Not found exception: one of the referenced entities doesn't exist. */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Internal server error. */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    getAlignmentStatistics: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description pangenome organism id */
                pangenomeOrgId: number;
                /** @description contig id part of the pangenome */
                contigId: number;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful operation. */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["AlignmentStatsResponse"];
                };
            };
            /** @description Validation exception: the request cannot be performed for the given input due to problems with the input.
             *     Example: user is not allowed to access referenced entities.
             *      */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Unauthorized API access. */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Not found exception: one of the referenced entities doesn't exist. */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Internal server error. */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    getPangenomeTrackFeatures: {
        parameters: {
            query?: {
                /** @description range start position */
                start?: number;
                /** @description range stop position */
                stop?: number;
                /** @description feature minimum length */
                minLength?: number;
            };
            header?: never;
            path: {
                pangenomeOrgId: number;
                contigId: number;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful operation. */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["TrackFeatureResponse"][];
                };
            };
            /** @description Validation exception: the request cannot be performed for the given input due to problems with the input.
             *     Example: user is not allowed to access referenced entities.
             *      */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Unauthorized API access. */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Not found exception: one of the referenced entities doesn't exist. */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Internal server error. */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    getContigsWithSyntenyFamilies: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description synteny organism id */
                syntenyOrgId: number;
                /** @description organism id */
                orgId: number;
                syntenyType: components["schemas"]["SyntenyTypeEnum"];
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful operation. */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": number[];
                };
            };
            /** @description Validation exception: the request cannot be performed for the given input due to problems with the input.
             *     Example: user is not allowed to access referenced entities.
             *      */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Unauthorized API access. */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Not found exception: one of the referenced entities doesn't exist. */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Internal server error. */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    getGeneFamilies: {
        parameters: {
            query: {
                contigIds: number[];
            };
            header?: never;
            path: {
                /** @description synteny organism id */
                syntenyOrgId: number;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful operation. */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["SyntenyFamilyResponse"][];
                };
            };
            /** @description Validation exception: the request cannot be performed for the given input due to problems with the input.
             *     Example: user is not allowed to access referenced entities.
             *      */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Unauthorized API access. */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Not found exception: one of the referenced entities doesn't exist. */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Internal server error. */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    getProteinFamilies: {
        parameters: {
            query: {
                contigIds: number[];
                condense?: boolean;
            };
            header?: never;
            path: {
                /** @description synteny organism id */
                syntenyOrgId: number;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful operation. */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["SyntenyFamilyResponse"][];
                };
            };
            /** @description Validation exception: the request cannot be performed for the given input due to problems with the input.
             *     Example: user is not allowed to access referenced entities.
             *      */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Unauthorized API access. */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Not found exception: one of the referenced entities doesn't exist. */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Internal server error. */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    getFeatureSyntenyFamilyMembers: {
        parameters: {
            query?: {
                condense?: boolean;
            };
            header?: never;
            path: {
                /** @description synteny organism id */
                syntenyOrgId: number;
                syntenyType: components["schemas"]["SyntenyTypeEnum"];
                featureId: number;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful operation. */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["SyntenyFamilyOrganismResponse"][];
                };
            };
            /** @description Validation exception: the request cannot be performed for the given input due to problems with the input.
             *     Example: user is not allowed to access referenced entities.
             *      */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Unauthorized API access. */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Not found exception: one of the referenced entities doesn't exist. */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Internal server error. */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    editSyntenyView: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @description view contents payload */
        requestBody: {
            content: {
                "application/json": components["schemas"]["CreateOrUpdateSyntenyViewRequest"];
            };
        };
        responses: {
            /** @description Successful operation. */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "text/plain": number;
                };
            };
            /** @description Validation exception: the request cannot be performed for the given input due to problems with the input.
             *     Example: user is not allowed to access referenced entities.
             *      */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Unauthorized API access. */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Not found exception: one of the referenced entities doesn't exist. */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Internal server error. */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    createSyntenyView: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @description view contents payload */
        requestBody: {
            content: {
                "application/json": components["schemas"]["CreateOrUpdateSyntenyViewRequest"];
            };
        };
        responses: {
            /** @description Successful operation. */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "text/plain": number;
                };
            };
            /** @description Validation exception: the request cannot be performed for the given input due to problems with the input.
             *     Example: user is not allowed to access referenced entities.
             *      */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Unauthorized API access. */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Not found exception: one of the referenced entities doesn't exist. */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Internal server error. */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    loadSyntenyView: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description synteny view id */
                viewId: number;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Successful operation. */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["SyntenyViewResponse"];
                };
            };
            /** @description Validation exception: the request cannot be performed for the given input due to problems with the input.
             *     Example: user is not allowed to access referenced entities.
             *      */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Unauthorized API access. */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Not found exception: one of the referenced entities doesn't exist. */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Internal server error. */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
}
export enum AlignmentDensityEnum {
    SINGLE = "SINGLE",
    LOW = "LOW",
    OFF = "OFF"
}
export enum FeatureType {
    gene = "gene",
    protein = "protein",
    transcript = "transcript"
}
export enum GenomicFeatureTypeEnum {
    GENE = "GENE",
    TRANSCRIPT = "TRANSCRIPT",
    TRANSCRIPT_LOCATION = "TRANSCRIPT_LOCATION",
    PROTEIN = "PROTEIN",
    PROTEIN_LOCATION = "PROTEIN_LOCATION",
    ORGANISM = "ORGANISM",
    CONTIG = "CONTIG",
    REGION_FLAG = "REGION_FLAG",
    COORDINATE = "COORDINATE",
    NUCLEOTIDE_FEATURE = "NUCLEOTIDE_FEATURE",
    AA_SEQUENCE_FEATURE = "AA_SEQUENCE_FEATURE",
    VCF_VARIANT = "VCF_VARIANT",
    MARKER = "MARKER",
    MARKER_NUS = "MARKER_NUS"
}
export enum MethodKeyEnum {
    fast = "fast",
    slow = "slow"
}
export enum PileupRenderingModeEnum {
    CONDENSED = "CONDENSED",
    EXPANDED = "EXPANDED"
}
export enum SequenceAnalyzerFeatureType {
    gene = "gene",
    protein = "protein",
    proteinLocation = "proteinLocation",
    transcript = "transcript",
    transcriptLocation = "transcriptLocation"
}
export enum SequenceExportFileType {
    msf = "msf",
    fasta = "fasta"
}
export enum SequenceFeatureTypeColorSetting {
    Identical = "Identical",
    Distinct = "Distinct",
    Shade = "Shade"
}
export enum SequenceType {
    dna = "dna",
    protein = "protein"
}
export enum SequencingTypeEnum {
    UNKNOWN = "UNKNOWN",
    NOT_SEQUENCED = "NOT_SEQUENCED",
    SEQUENCED_ASSEMBLY = "SEQUENCED_ASSEMBLY",
    RE_SEQUENCED = "RE_SEQUENCED",
    RE_SEQUENCED_VCF = "RE_SEQUENCED_VCF",
    VECTOR = "VECTOR",
    VIRTUAL = "VIRTUAL",
    PROTEIN_SYNTENY = "PROTEIN_SYNTENY",
    PANGENOME = "PANGENOME",
    GENE_SYNTENY = "GENE_SYNTENY"
}
export enum SeverityConstants {
    DEBUG = "DEBUG",
    DETAIL = "DETAIL",
    INFO = "INFO",
    WARN = "WARN",
    ERROR = "ERROR"
}
export enum SyntenyTypeEnum {
    GENE = "GENE",
    PROTEIN = "PROTEIN",
    GENOME_ALIGNMENT = "GENOME_ALIGNMENT"
}
export enum TrackEnum {
    GENE = "GENE",
    TRANSCRIPT_LOCATION = "TRANSCRIPT_LOCATION",
    PROTEIN_LOCATION = "PROTEIN_LOCATION",
    VARIANT = "VARIANT",
    VCF_VARIANT = "VCF_VARIANT",
    SEQUENCE = "SEQUENCE",
    BLAST_ALIGNMENT = "BLAST_ALIGNMENT",
    PROFILE = "PROFILE",
    NUCLEOTIDE_FEATURE = "NUCLEOTIDE_FEATURE",
    AA_SEQUENCE_FEATURE = "AA_SEQUENCE_FEATURE",
    MARKER_NUS = "MARKER_NUS",
    BED_FEATURE = "BED_FEATURE",
    COORDINATE = "COORDINATE",
    NGS = "NGS",
    COORDINATE_LIST = "COORDINATE_LIST"
}
export enum TrackTextEnum {
    NONE = "NONE",
    INNER = "INNER",
    OUTER = "OUTER"
}
